export interface EnvironmentSpecificEnv {
  production: boolean;
  googleAnalytics: {
    id: string;
    tag: string;
  };
  recaptchaKey: string;
  oktaClientId: string;
  oktaIssuer: string;
  environmentName: EnvironmentName;
  splitKey: string;
  showOktaSignInButton: boolean;
  apiSubDomain: string;
}

export enum EnvironmentName {
  LOCAL,
  DEV,
  QA,
  STAGE,
  PROD,
  DEMO,
}
